<template>
    <div>
        <breadCrumb 
            :icon="'fa-calendar-day'"
            :category="$t(`sideNav.navSalonSetting`)"
            :subCategory="$t(`subMenu.salon_setting_roster`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="py-4">
            <div class="panel mb-0">
                <div class="panel-hdr border-bottom-0 pt-3 pb3 d-block">
                    <staffRosterFilter ref="staffRosterFilter" @filterStaffRoster="filterStaffRoster"></staffRosterFilter>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                            {{$t('table.no_records')}}
                        </div>
                        <div v-show="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <scheduler ref="scheduler" @toggleStaffForm="toggleStaffForm" @toggleStaffActionForm="toggleStaffActionForm"></scheduler>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="loadingModal" :class="{'show': isSpinnerShow}" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered justify-content-center">
                <div class="loading-modal-content border-0 ">
                    <div class="modal-body text-center">
                        <div class="spinner-border text-light" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="text-light mt-2">{{$t('message.data.fetching_wait')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <button type="button" class="close" @click="resetStaffRosterForm">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body edit-modal-body">
                        <staffRosterForm ref="staffRosterForm" :breakType="breakType" @returnRoster="returnRoster"></staffRosterForm>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': toggleActionModal }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <button type="button" class="close" @click="returnRoster">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <staffRosterActionForm ref="staffRosterActionForm" @returnRoster="returnRoster"></staffRosterActionForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import BreadCrumb from './../../Bread_Crumb.vue'
import Scheduler from './../../Scheduler.vue'
import StaffRosterForm from './Staff_Roster_Form.vue'
import StaffRosterActionForm from './Staff_Roster_Action_Form.vue'
import StaffRosterFilter from './Staff_Roster_Filter.vue'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'staffRoster',
    components:{
        BreadCrumb,
        StaffRosterFilter,
        StaffRosterForm,
        StaffRosterActionForm,
        Scheduler
    },
    data(){
        return{
            filterObj: {},
            toggleActionModal: false,
            toggleModal: false,
            isSpinnerShow: false, 
            breakType: [],
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
        }
    },
    methods:{
        filterStaffRoster(obj){
            this.filterObj = Object.assign({}, obj)
            var dateFilter = '&startBreakDate=' + moment(obj.selectedDateRange.startDate).unix() + '&endBreakDate=' + moment(obj.selectedDateRange.endDate).unix() 
            var searchFilter = obj.search == '' ? '' : '&search=' + obj.search
            var staffFilter = obj.staff == 'all' ? '' : '&staffID=' + obj.staff
            var statusFilter = obj.status == 'all' ? '' : '&status=' + obj.status
            var breakFilter = obj.breakType == 'all' ? '' : '&DfBreakTypeID=' + obj.breakType

            let QUERY_STRING = dateFilter + searchFilter + staffFilter + statusFilter + breakFilter
            this.setStaffRoster(QUERY_STRING)
        },
        async setStaffRoster(strFilter){
            this.isSpinnerShow = true
            var result = await this.getStaffRoster(this.filterObj.outlet.id, strFilter)
            var staffs = await this.getStaffItems(this.filterObj.outlet.id, this.filterObj.search)

            this.$refs.staffRosterFilter.setStaffList(staffs)

            var filterStaff = JSON.parse(JSON.stringify(staffs))
            if(this.filterObj.staff != 'all'){
                filterStaff = filterStaff.filter(obj=> obj.staffID == this.filterObj.staff)
            }

            if(result.length != 0){
                var group = _.groupBy(result, 'staffID')

                filterStaff.forEach(obj=>{
                    for(var id in group){
                        if(obj.staffID == parseInt(id)){
                            obj.break = group[id]
                        }
                    }
                })

                filterStaff.forEach(obj=>{
                    if(obj.break == undefined){
                        obj.break = []
                    }
                })
            }else{
                filterStaff.forEach(obj=>{
                    obj.break = []
                })
            }

            this.totalEntries = filterStaff.length;

            this.$refs.scheduler.setScheduler(this.filterObj.selectedDateRange, filterStaff)
            this.isSpinnerShow = false
        },
        async getStaffRoster(outlet, strFilter){
            let $vm = this;
            let QUERY_STRING = '?outletID=' + outlet +  strFilter
            const url =  this.$api.STAFF_ROSTER + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result          
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        async getStaffItems(outlet, search){
            let $vm = this;
            let QUERY_STRING =  "/" + outlet + this.$api.STAFF + (search == '' ? '' : '?search=' + search)
            const url =  this.$api.OUTLET + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.staff
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
            return result
        },
        filterRosterByDate(result, date){
            var tsStart = moment(date.startDate).unix()
            var tsEnd = moment(date.endDate).unix()

            var filtered = result.filter(obj=> obj.breakDate >= tsStart && obj.breakDate <= tsEnd); 
            return filtered
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1;
                this.setStaffRoster()
            }
        },
        async getBreakType(){
            let $vm = this;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: $vm.$api.BREAK_TYPE,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
            return result
        },
        toggleStaffForm(obj, date){
            this.$refs.staffRosterForm.setStaffForm(obj, this.filterObj.outlet, date)
            this.toggleModal = true
        },
        returnRoster(){
            this.filterStaffRoster(this.filterObj)
            this.toggleModal = this.toggleActionModal = false
        },
        resetStaffRosterForm(){
            this.$refs.staffRosterForm.resetForm()
            this.toggleModal = this.toggleActionModal = false
        },
        toggleStaffActionForm(obj, date){
            this.$refs.staffRosterActionForm.setStaffRosterActionForm(obj, this.filterObj.outlet, date)
            this.toggleActionModal = true
        }
    },
    async mounted(){
        let $vm = this
        var breakType = await $vm.getBreakType()
        $vm.breakType = breakType
        $vm.$refs.staffRosterFilter.setBreakType(breakType)
        
    }
}
</script>
<style scoped>
.show{
    display: block;
}
.loading-modal-content{
    background: transparent;
    box-shadow: none;
}
.edit-modal-body{
    min-height: 50vh;
    max-height: 80vh;
    overflow-y: auto;
}
</style>